import NoteEditorModal from './NoteEditorModal';

export default NoteEditorModal;
